import { ScrollReveal } from './ScrollReveal';

interface SectionHeaderProps {
  label: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
}

export function SectionHeader({ label, title, subtitle, align = 'left' }: SectionHeaderProps) {
  return (
    <ScrollReveal className={`section-header ${align === 'center' ? 'section-header-center' : ''}`}>
      <span className="section-label">{label}</span>
      <h2 className="section-title">{title}</h2>
      {subtitle && <p className="section-subtitle">{subtitle}</p>}
    </ScrollReveal>
  );
}
